export const PXTextMedia = (function() {
	'use strict';

	var $blocks;

	function init() {
		$blocks = $('.pxblock--text-media');
		if(!$blocks.length > 0) return null;
		// events();
		videoButtons();
	}

	function events() {}

	function videoButtons() {
		$blocks.each(function(){
			let $this = $(this);
			let $video = $this.find('.video-js');
			let $button = $this.find('.video-js__start-btn');

			if($video && $button){
				$button.on('click', function(){
					$video.get(0).paused ? $video.get(0).play() : $video.get(0).pause();
					$( '.video-js__start-btn svg' ).toggle();
				});
			}
			// console.log($video);
			
		});
	}

	return {
		init: init
	};
})();
